//import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import http from "./httpClient.js";

export async function signup(data) {
    const response = await http.post(`/users/signup`, data);
    return response.data;
}

export async function login(data) {
    const response = await http.post(`/users/login`, data);
    return response.data;
}

export async function loginWithSocialMedia(tokenGoogle) {
    const response = await http.post(
        `/users/login-social-media`,
        {},
        {
            headers: {
                Authorization: `Bearer ${tokenGoogle}`,
            },
        }
    );
    return response.data;
}

export async function loginWithGoogleAfterVerifyEmail(email, googleToken) {
    const response = await http.post(`/users/google-login-after-verification`, {
        email,
        googleToken,
    });
    return response.data;
}

export function saveLocalStorage(data) {
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));
}
export function removeLocalStorage() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('school');
}
export function replaceUserDataOnLocalStorage(data) {
    localStorage.setItem('user', JSON.stringify(data));
}
export function showTheError(errorMessage) {
    const error = new Error(errorMessage);
    throw error;
}
export async function verifyEmail(token, email) {
    const response = await http.post(`/users/verify-email`, { token, email });
    return response.data;
}
export async function resendVerificationLink(email) {
    const response = await http.post(`/users/resend-verification-email`, { email });
    return response.data;
}
export async function setPassword(email, password, passwordConfirm) {
    const response = await http.post(`/users/set-password`, {
        email,
        password,
        passwordConfirm,
    });
    return response.data;
}